import { Form, Select } from "antd";
import { useEffect, useState } from "react";
import { getData } from "../../repository/api";

const { Option } = Select;

const AccountingInformation = ({ form }) => {
  const [accounts, setAccounts] = useState([]);

  useEffect(() => {
    fetchAccounts();
  }, []);

  const fetchAccounts = async () => {
    try {
      const response = await getData("/GetAccount/");
      const mapped = response.map((item) => ({
        name: item.AccountName,
        value: item.id,
      }));
      setAccounts(mapped);
    } catch (error) {
      console.error("Error fetching accounts:", error);
    }
  };

  return (
    <div className="d-flex gap-5">
      <Form.Item
        label="Income Account"
        name="IncomeAccount_id"
        rules={[
          {
            required: true,
            message: "Please select income account",
          },
        ]}
      >
        <Select placeholder="Select income account">
          {accounts.map((acc) => (
            <Option key={acc.value} value={acc.value}>
              {acc.name}
            </Option>
          ))}
        </Select>
      </Form.Item>

      <Form.Item
        label="Expense Account"
        name="ExpenseAccount_id"
        rules={[
          {
            required: true,
            message: "Please select expense account",
          },
        ]}
      >
        <Select placeholder="Select expense account">
          {accounts.map((acc) => (
            <Option key={acc.value} value={acc.value}>
              {acc.name}
            </Option>
          ))}
        </Select>
      </Form.Item>
    </div>
  );
};
export default AccountingInformation;
